export const GET_HOST = "GET_HOST";